"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetObjectTorrentOutput = {
    type: "structure",
    required: [],
    members: {
        Body: {
            shape: {
                type: "blob"
            },
            streaming: true
        },
        RequestCharged: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-request-charged"
        }
    },
    payload: "Body"
};
//# sourceMappingURL=GetObjectTorrentOutput.js.map